
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1lyyo_1vl56_1",
  "toolbar": "awsui_toolbar_1lyyo_1vl56_5",
  "notifications": "awsui_notifications_1lyyo_1vl56_11",
  "content": "awsui_content_1lyyo_1vl56_16"
};
  